export const SET_UNPAID_DRIVERS = 'SET_UNPAID_DRIVERS';


export const actionSetUnpaidDrivers = unpaidDriver => ({
    type: SET_UNPAID_DRIVERS,
    payload: unpaidDriver
})